import React from 'react';
import get_bundle from '../../domain/get_bundle';
import Locale from '../../domain/Locale';
import ProductDomain from '../../domain/Product';
import User from '../../domain/User';
import Color from '../../domain/Color';
import SponsorDomain from '../../domain/Sponsor';
import Registered from '../../domain/Registered';
import Layout from '../../components/Layout';
import MarkdownComponent from '../../components/MarkdownComponent';
import AdvBoxes from '../../components/AdvBoxes';
import AdvBox from '../../components/AdvBox';
import Sponsor from '../../components/Sponsor';
import Console from '../../components/Console';
import ProductComponent from '../../components/Product';
import ShareBox from '../../components/ShareBox';
import Tips from '../../components/Tips';
import Lasts from '../../components/Lasts';
import ProductDetails from '../../components/ProductDetails';
import ProductCard from '../../components/ProductCard';
import ProductHeader from '../../components/header/Product';
import LucidTutorial from '../../components/LucidTutorial';
import StatusLucid from '../../domain/StatusLucid';
import { t, props } from 'tcomb-react';
const doShowBonus = false;
const doShowTimeAgo = true;

@props({
  locale: Locale,
  product: ProductDomain,
  user: User,
  sponsor: t.maybe(SponsorDomain),
  message: t.maybe(t.ReactElement),
  oldPrice: t.maybe(t.Num),
  doShowConsole: t.Bool,
  doShowShare: t.Bool,
  advBoxes: t.Arr,
  doReduce: t.Func,
  doShare: t.Func,
  goBuildOrder: t.Func,
  goPurchase: t.Func,
  themeBgColor: t.maybe(Color),
  themeBtnColor: t.maybe(Color),
  themeBgFontColor: t.maybe(Color),
  themeBtnFontColor: t.maybe(Color),
  doAcceptCookies: t.maybe(t.Func),
  goLogin: t.Func,
  goAccount: t.Func,
  goPurchases: t.Func,
  goChangePassword: t.Func,
  doLogout: t.Func,
  goCatalog: t.maybe(t.Func),
  goLattices: t.maybe(t.Func),
  partners: t.maybe(t.Obj),
  showLucidTutorial: t.maybe(t.Bool),
  statusLucidTutorial: t.maybe(StatusLucid)
})
export default class Product extends React.Component {

  constructor(...args) {
    super(...args);
    this.state = {
      showModal: true
    }
  }

  getSponsorTitle() {
    if (!this.props.sponsor.name) {
      return null;
    }
    return (<h1>{this.props.sponsor.name}</h1>);
  }

  getSponsorDescription() {
   if (!this.props.sponsor.description) {
      return null;
    }
    return (<h2><MarkdownComponent>{this.props.sponsor.description}</MarkdownComponent></h2>);
  }

  getBgColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.bg_color;
  }

  getColor() {
    if (!this.props.sponsor) {
      return null;
    }
    return this.props.sponsor.color;
  }

  getAdvBoxes() {
    if (!this.props.advBoxes || this.props.advBoxes.length === 0) {
      return null;
    }

    let advBoxes = this.props.advBoxes.map(function (advBox, index) {
      function onClick () {
        window.open(advBox.link);
      }

      return (
        <AdvBox
            key={index}
            image={advBox.image}
            title={advBox.title}
            onClick={onClick}  />
      );
    });

    return (<AdvBoxes advBoxes={advBoxes} title={get_bundle(this.props.locale).product.title_adv}/>);
  }


  getHeader() {
    return (<ProductHeader
      user={this.props.user}
      goLogin={this.props.goLogin}
      goCatalog={this.props.goCatalog}
      goLattices={this.props.goLattices}
      goAccount={this.props.goAccount}
      goPurchases={this.props.goPurchases}
      goChangePassword={this.props.goChangePassword}
      doLogout={this.props.doLogout}
      locale={this.props.locale}
      color={this.getColor()}
      themeBtnColor={this.props.themeBtnColor}
      themeBtnFontColor={this.props.themeBtnFontColor} />);
  }

  getSponsor() {
    const options = {
      isWelcome: Registered.is(this.props.user),
      showTutorial: true
    };
    return (<Sponsor sponsor={this.props.sponsor} locale={this.props.locale} options={options} />);
  }

  getSponsorClaim() {
    if (!this.props.sponsor) {
      return null;
    }

    return (
      <div className="cell sponsor-claim">
        {this.getSponsorTitle()}
        {this.getSponsorDescription()}
      </div>
    );
  }

  getSmallLayout() {
    const {locale, product} = this.props;
    const bundle = get_bundle(locale);
    return (
      <div className="product-mobile">
        {this.getSponsorClaim()}
        <div className="cell">
          <div>
            <ProductCard locale={locale} product={product} themeBgFontColor={this.props.themeBgFontColor} themeBgColor={this.props.themeBgColor} />
          </div>
        </div>
        <div className="cell">
          <Console
            doShowConsole={this.props.doShowConsole}
            locale={locale}
            themeBgColor={this.props.themeBgColor}
            themeBtnColor={this.props.themeBtnColor}
            themeBgFontColor={this.props.themeBgFontColor}
            themeBtnFontColor={this.props.themeBtnFontColor}
            message={this.props.message}
            product={product}
            goBuildOrder={this.props.goBuildOrder}
            goPurchase={this.props.goPurchase}
            doReduce={this.props.doReduce}
            oldPrice={this.props.oldPrice}
            doShowBonus={doShowBonus}
            doShowTimeAgo={doShowTimeAgo}
            doShowProductName
            doShowArrowRight={false} />
        </div>
        <div className="cell">
          <ProductDetails locale={locale} product={product} themeBtnColor={this.props.themeBtnColor} />
        </div>
        <div className="cell">
          <ShareBox doShowShare={this.props.doShowShare} title={bundle.product.social} doShare={this.props.doShare} />
        </div>
      </div>
    );
  }

  getLasts() {
    return (<Lasts locale={this.props.locale} product={this.props.product} />);
  }

  getTips() {
    return (<Tips locale={this.props.locale} />);
  }

  callback = () => {
    this.setState({showModal: false})
  }

  getLargeLayout() {
    const {locale, product} = this.props;
    const bundle = get_bundle(locale);
    return (
      <div className="product-desktop">
        <div className="large-35 medium-40 large-pull-right medium-pull-right">
          <div className="cell">
            <Console
              doShowConsole={this.props.doShowConsole}
              locale={locale}
              themeBgColor={this.props.themeBgColor}
              themeBtnColor={this.props.themeBtnColor}
              themeBgFontColor={this.props.themeBgFontColor}
              themeBtnFontColor={this.props.themeBtnFontColor}
              message={this.props.message}
              product={product}
              goBuildOrder={this.props.goBuildOrder}
              goPurchase={this.props.goPurchase}
              doReduce={this.props.doReduce}
              oldPrice={this.props.oldPrice}
              doShowBonus={doShowBonus}
              doShowTimeAgo={doShowTimeAgo}
              doShowProductName
              doShowArrowRight={false} />
            { this.getTips() }
            { this.getLasts() }
            <ShareBox doShowShare={this.props.doShowShare} title={bundle.product.social} doShare={this.props.doShare} />
          </div>
        </div>
        <div className="large-65 medium-60 large-pull-left medium-pull-left">
          <div className="cell">
            <ProductComponent showDetails locale={locale} product={product} themeBtnColor={this.props.themeBtnColor}  themeBgFontColor={this.props.themeBgFontColor} themeBgColor={this.props.themeBgColor}/>
          </div>
        </div>
      </div>
    );
  }

  getLucidTutorial = () => {
    if ( this.props.showLucidTutorial && this.state.showModal) {
      return (<LucidTutorial width='600' status={this.props.statusLucidTutorial} locale={this.props.locale} callback={this.callback} />)  
    }
    return null
  }

  render() {
    const {locale} = this.props;
    return (
      <Layout header={this.getHeader()} partners={this.props.partners} bgColor={this.getBgColor()} sponsor={this.getSponsor()} locale={locale} doAcceptCookies={this.props.doAcceptCookies}>
        {this.getLucidTutorial()}
        <div id="product">
          <div className="cols">
            <div className="large-100 medium-100 small-hide">
              {this.getLargeLayout()}
            </div>
            <div className="small-100 large-hide medium-hide small-show">
              {this.getSmallLayout()}
            </div>
          </div>
          {this.getAdvBoxes()}
        </div>
        
      </Layout>
    );
  }
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/product/route/Product.js
 **/